var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBjb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2694_389)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2694_389)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 6.63158,
    fill: "url(#paint0_radial_2694_389)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2694_389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 50
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 6.63158,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2694_389)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 50.0001C37 50.0001 48.5 49.0001 57 45.5001C65.7893 41.881 70 37.9306 70 31.5001C70 16.5001 70 50.0001 70 50.0001H37Z",
    fill: "#165781"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2694_389)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5067 13.5073L26.1478 15.2758C29.687 15.2623 40.8221 11.1469 41.3393 8.69114C41.3393 8.69153 41.3733 8.53016 41.4068 8.36878C41.4401 8.20727 41.4727 8.0459 41.4704 8.0459C36.6467 11.3107 29.359 13.5003 26.5067 13.5073ZM25.8314 16.5592L25.4972 18.1876C28.9091 18.1805 40.1711 14.0582 40.6884 11.6031L40.8312 10.9002C35.843 14.3745 28.8571 16.4745 25.8314 16.5592ZM25.1043 19.5298L24.7578 21.2367L24.7599 21.2971C28.2098 21.2193 39.4209 17.1656 39.9371 14.7137L40.1073 13.8737C36.2412 16.5768 28.2179 19.5466 25.1043 19.5298Z",
    fill: "url(#paint1_linear_2694_389)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2694_389)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.05932 24.9829H9.35206V29.5248H9.38172C9.84229 28.7183 10.6742 28.1953 11.8333 28.1953C13.6166 28.1953 14.8787 29.6889 14.8634 31.8866C14.8634 34.4701 13.2448 35.7554 11.6396 35.7554C10.5995 35.7554 9.76729 35.3517 9.23303 34.3958H9.18808L9.12981 35.5911H8C8.03005 35.0976 8.05932 34.3649 8.05932 33.7233V24.9829ZM9.35206 32.6923C9.35206 32.8565 9.38172 33.02 9.41177 33.1703C9.66407 34.0812 10.4215 34.7096 11.3723 34.7096C12.7391 34.7096 13.5563 33.5885 13.5563 31.9299C13.5563 30.4807 12.8131 29.2403 11.417 29.2403C10.5251 29.2403 9.69334 29.8532 9.42562 30.8548C9.39635 31.0043 9.35206 31.1826 9.35206 31.3923V32.6923Z",
    fill: "#165781"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3857 33.8574C21.3857 34.4855 21.4154 35.0977 21.5043 35.591H20.3159L20.2116 34.6792H20.1673C19.7655 35.2479 18.9927 35.7552 17.9687 35.7552C16.5123 35.7552 15.7705 34.725 15.7705 33.6792C15.7705 31.9299 17.3148 30.9734 20.0926 30.9895V30.8392C20.0926 30.2419 19.9296 29.1661 18.4592 29.1661C17.7896 29.1661 17.0923 29.3745 16.5866 29.7043L16.289 28.8375C16.8835 28.4495 17.7465 28.1953 18.6515 28.1953C20.8508 28.1953 21.3857 29.7043 21.3857 31.153V33.8574ZM20.1229 31.8998C18.6958 31.8696 17.0771 32.1246 17.0771 33.5282C17.0771 34.3803 17.6414 34.7846 18.3095 34.7846C19.246 34.7846 19.8399 34.1858 20.0479 33.5738C20.0926 33.4383 20.1229 33.2895 20.1229 33.1555V31.8998Z",
    fill: "#165781"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3917 30.3155C23.3917 29.5687 23.3759 28.9575 23.332 28.3586H24.4898L24.5648 29.5539H24.5945C24.9514 28.8676 25.7833 28.1943 26.9721 28.1943C27.9661 28.1943 29.5118 28.7924 29.5118 31.2722V35.5901H28.204V31.4217C28.204 30.2558 27.7742 29.2844 26.5405 29.2844C25.6789 29.2844 25.0097 29.8978 24.787 30.6301C24.7277 30.7936 24.6977 31.0181 24.6977 31.2435V35.5901H23.3917",
    fill: "#165781"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7209 31.676H32.7505C32.9287 31.4219 33.1808 31.1082 33.3897 30.8541L35.4991 28.3589H37.0736L34.2956 31.3328L37.4592 35.5903H35.8705L33.3897 32.1246L32.7209 32.8714V35.5903H31.4277V24.9829H32.7209",
    fill: "#165781"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2314 28.615C48.1826 28.5569 48.1343 28.4979 48.0827 28.4449C47.9985 28.3565 47.9043 28.274 47.804 28.1959C47.2633 27.7512 46.6094 27.4896 45.9046 27.4896C45.1442 27.4896 44.4438 27.7967 43.8799 28.3079C43.8635 28.3183 43.8492 28.33 43.8328 28.3388C43.8126 28.3498 43.784 28.3639 43.7507 28.3549C43.6581 28.3307 43.5592 28.2313 43.5585 28.0892V25.1323C43.5585 24.9466 43.4069 24.7964 43.2213 24.7964H41.7904C41.6037 24.7964 41.4533 24.9466 41.4533 25.1323V25.2345C41.4533 25.2391 41.4521 25.242 41.4521 25.2456V25.5889L41.4548 35.1218C41.4548 35.311 41.6071 35.4642 41.7945 35.4642H43.0898C43.1723 35.4642 43.2473 35.4334 43.3059 35.3833C43.3084 35.3817 43.311 35.3817 43.3122 35.3804C43.3143 35.3788 43.3147 35.3766 43.3161 35.375C43.344 35.3508 43.3656 35.3214 43.3838 35.2897H43.3846C43.4069 35.2478 43.4218 35.2035 43.4268 35.1542C43.4527 34.9436 43.5952 34.8273 43.6837 34.8574C43.7141 34.867 43.743 34.8817 43.7726 34.9031C43.803 34.9222 43.8328 34.942 43.862 34.9612C43.9498 35.026 44.3358 35.292 44.635 35.4259C44.7858 35.493 45.2662 35.6571 45.8237 35.6571C46.3818 35.6571 46.7782 35.5328 46.8716 35.5076C46.9656 35.4826 47.0578 35.4511 47.1465 35.4097C47.5833 35.2213 47.9345 34.9612 48.2013 34.6328C48.4653 34.3102 48.6842 33.928 48.861 33.489C49.1247 32.9115 49.2747 32.2487 49.2747 31.5433C49.2747 30.3906 48.8736 29.353 48.2314 28.615ZM45.2774 34.1349C44.2289 34.1349 43.3787 32.9985 43.3787 31.5985C43.3787 30.1977 44.2289 29.0621 45.2774 29.0621C46.3249 29.0621 47.1744 30.1977 47.1744 31.5985C47.1744 32.9985 46.3249 34.1349 45.2774 34.1349Z",
    fill: "#165781"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2694_389)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.9988 28.3383C52.9973 28.3193 52.9956 28.3001 52.994 28.2817V28.029C52.994 27.8391 52.8414 27.6851 52.6528 27.6851H51.2114C51.0221 27.6851 50.8691 27.8391 50.8691 28.029V35.8416C50.8618 36.0404 50.6212 36.313 50.3429 36.3807C50.2148 36.4205 50.0867 36.4389 49.9571 36.433C49.8281 36.4286 49.7397 36.4808 49.6894 36.5905C49.6699 36.6391 49.6557 36.7047 49.6443 36.7849C49.6357 36.8645 49.6466 37.7019 49.6528 37.7711C49.658 37.8412 49.6699 37.9001 49.6894 37.9501C49.7491 38.0399 49.8535 38.0995 50.0014 38.1298C50.0509 38.1504 51.0086 38.1526 51.6521 37.9957C51.9052 37.9346 52.1081 37.8116 52.2775 37.6827C52.4446 37.5523 52.5938 37.3882 52.7235 37.1879C52.8725 36.9492 52.9538 36.648 52.969 36.2842C52.9736 36.1745 52.994 35.888 52.994 35.8541V28.7559C52.9956 28.7177 52.9966 28.6795 52.9988 28.6381C53.0035 28.5386 53.0035 28.4386 52.9988 28.3383",
    fill: "#165781"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2694_389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 54,
    y: 24,
    width: 9,
    height: 12
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.5091 35.6571V24.7964L54.687 24.7964V35.6571H62.5091V35.6571Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2694_389)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4657 28.615C61.4178 28.5569 61.3696 28.4979 61.317 28.4449C61.2329 28.3565 61.1384 28.274 61.0389 28.1959C60.4982 27.7512 59.8442 27.4896 59.1389 27.4896C58.379 27.4896 57.6792 27.7967 57.1154 28.3079C57.0982 28.3183 57.0839 28.33 57.0668 28.3388C57.0471 28.3498 57.0195 28.3639 56.986 28.3549C56.8933 28.3307 56.794 28.2313 56.7924 28.0892V25.1323C56.7924 24.9466 56.6417 24.7964 56.4561 24.7964H55.0257C54.8388 24.7964 54.6881 24.9466 54.6881 25.1323V25.2345C54.6881 25.2391 54.687 25.242 54.687 25.2456V25.5889L54.6888 35.1218C54.6888 35.311 54.8415 35.4642 55.0296 35.4642H56.3236C56.407 35.4642 56.4824 35.4334 56.5413 35.3833C56.5432 35.3817 56.5447 35.3817 56.5465 35.3804C56.5486 35.3788 56.5494 35.3766 56.5514 35.375C56.5776 35.3508 56.6008 35.3214 56.6189 35.2897L56.6197 35.2881C56.6417 35.2478 56.6567 35.2035 56.6614 35.1542C56.6875 34.9436 56.8292 34.8273 56.9181 34.8574C56.9486 34.867 56.9785 34.8817 57.0079 34.9031C57.037 34.9222 57.0668 34.942 57.0971 34.9612C57.1843 35.026 57.5709 35.292 57.8696 35.4259C58.0205 35.493 58.5002 35.6571 59.0589 35.6571C59.6161 35.6571 60.0119 35.5328 60.1063 35.5076C60.2004 35.4826 60.2923 35.4511 60.3813 35.4097C60.8166 35.2213 61.1691 34.9612 61.4365 34.6328C61.7004 34.3102 61.9191 33.928 62.0959 33.489C62.359 32.9115 62.5092 32.2487 62.5092 31.5433C62.5092 30.3906 62.1075 29.353 61.4657 28.615ZM58.5122 34.1349C57.4636 34.1349 56.6138 32.9985 56.6138 31.5985C56.6138 30.1977 57.4636 29.0621 58.5122 29.0621C59.5601 29.0621 60.4095 30.1977 60.4095 31.5985C60.4095 32.9985 59.5601 34.1349 58.5122 34.1349Z",
    fill: "#165781"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.9061 24.8828C51.7011 24.8857 51.5206 24.9322 51.3653 25.0234C51.2134 25.117 51.0951 25.2422 51.0113 25.3953C50.9241 25.5516 50.8809 25.7232 50.8809 25.9139C50.8809 26.098 50.9241 26.2645 51.0051 26.4177C51.0856 26.5702 51.201 26.6924 51.3467 26.7858C51.496 26.8765 51.6699 26.9235 51.8692 26.9265C52.0929 26.9235 52.2824 26.8765 52.4377 26.7858C52.593 26.6924 52.7107 26.5702 52.7917 26.4177C52.8726 26.2645 52.9126 26.098 52.9126 25.9139C52.9126 25.7232 52.8697 25.5516 52.7885 25.3953C52.708 25.2422 52.59 25.117 52.4403 25.0234C52.2916 24.9322 52.1114 24.8857 51.9061 24.8828",
    fill: "#165781"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2694_389",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35 25) rotate(37.5947) scale(58.9168 57.1199)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E5E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2694_389",
    x1: 24.1176,
    y1: 16.3281,
    x2: 44.2897,
    y2: 15.2011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#175882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBC71B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2694_389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2694_389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2694_389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 31,
    fill: "white",
    transform: "translate(8 8)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2694_389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 14,
    fill: "white",
    transform: "translate(8 24.7354)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2694_389"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 11,
    fill: "white",
    transform: "translate(49.5493 27.6265)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBjb);
export default __webpack_public_path__ + "static/media/bjb.1c5f226cd44d1e32e2341b6bcbbe7988.svg";
export { ForwardRef as ReactComponent };